import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { triggerBackboneEvent } from 'libs/utils/backbone';
import { getLocalStorageItem, setLocalStorageItem } from 'libs/utils/localStorage';

const buildStorageConstruct = () => ({
  pending: [],
  outgoing: []
});

class Store {
  constructor(namespace) {
    _defineProperty(this, "namespace", void 0);

    this.namespace = namespace;
    this.prepare();
  }

  prepare() {
    const storage = buildStorageConstruct();
    const currentData = this.events;

    if (!currentData) {
      setLocalStorageItem(this.namespace, JSON.stringify(storage));
    }
  }

  get events() {
    const data = getLocalStorageItem(this.namespace);

    if (!data) {
      return buildStorageConstruct();
    }

    try {
      return JSON.parse(data);
    } catch (exception) {
      return buildStorageConstruct();
    }
  }

  add(event) {
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'pending';
    const events = this.events.pending;
    events.push(event);

    const data = _objectSpread(_objectSpread({}, this.events), {}, {
      [type]: events
    });

    if (process.env.NEXT_PUBLIC_NEXT_JS !== 'true') {
      triggerBackboneEvent('event:react-event-tracker', event);
    }

    setLocalStorageItem(this.namespace, JSON.stringify(data));
  }

  movePending() {
    const events = this.events.pending;
    events.forEach(event => {
      this.add(event, 'outgoing');
    });
    this.clear('pending');
  }

  clear() {
    let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pending';

    const data = _objectSpread(_objectSpread({}, this.events), {}, {
      ["".concat(type)]: []
    });

    setLocalStorageItem(this.namespace, JSON.stringify(data));
  }

}

export default Store;